"use strict";
// Copyright (C) 2017-2026 Smart code 203358507
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var components_1 = require("stremio/components");
var Logo_1 = __importDefault(require("./Logo"));
var ChannelColumn_less_1 = __importDefault(require("./ChannelColumn.less"));
var ChannelColumn = function (_a) {
    var innerRef = _a.innerRef, width = _a.width, rowHeight = _a.rowHeight, channels = _a.channels, skeletonRows = _a.skeletonRows, style = _a.style;
    return (react_1.default.createElement("div", { className: ChannelColumn_less_1.default['channel-column'], style: { width: width } },
        react_1.default.createElement("div", { ref: innerRef, className: ChannelColumn_less_1.default['inner'], style: style }, skeletonRows > 0 ?
            Array.from({ length: skeletonRows }, function (_, index) { return (react_1.default.createElement("div", { key: index, className: ChannelColumn_less_1.default['cell'], style: { height: rowHeight } },
                react_1.default.createElement("div", { className: ChannelColumn_less_1.default['skeleton'] }))); })
            :
                channels.map(function (channel) {
                    var _a, _b, _c, _d;
                    return (react_1.default.createElement(components_1.Button, { key: channel.id, className: ChannelColumn_less_1.default['cell'], style: { height: rowHeight }, href: (_d = (_b = (_a = channel.deepLinks) === null || _a === void 0 ? void 0 : _a.metaDetailsStreams) !== null && _b !== void 0 ? _b : (_c = channel.deepLinks) === null || _c === void 0 ? void 0 : _c.metaDetailsVideos) !== null && _d !== void 0 ? _d : undefined, title: channel.name },
                        react_1.default.createElement(Logo_1.default, { src: channel.logo, name: channel.name })));
                }))));
};
exports.default = ChannelColumn;
